var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Dropdown from '../dropdown';
import { StyledLanguageSwitch } from './style';
var LanguageSwitch = /** @class */ (function (_super) {
    __extends(LanguageSwitch, _super);
    function LanguageSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event, data) {
            if (_this.props.onChange) {
                _this.props.onChange(data.value);
            }
        };
        return _this;
    }
    LanguageSwitch.prototype.render = function () {
        return (React.createElement(StyledLanguageSwitch, { className: "lang-switch" },
            React.createElement(Dropdown, { options: this.props.locales, defaultValue: this.props.locales[0].value, onChange: this.handleChange, inline: true })));
    };
    return LanguageSwitch;
}(React.Component));
Object.assign(LanguageSwitch, {
    displayName: 'LanguageSwitch',
});
export default LanguageSwitch;
//# sourceMappingURL=index.js.map